const handleTooltips = function (el) {
	el.addEventListener('mouseenter', () => {
		const text = el.getAttribute('title');
		if (text) {
			const tooltip = document.createElement('span');
			tooltip.classList.add('Tooltip');
			tooltip.textContent = text;
			//const tooltip = '<span class="Tooltip" data-tooltip-message>' + text + '</span>';
			el.classList.add('Tooltip-parent');
			el.removeAttribute('title');
			el.setAttribute('aria-label', text);
			el.appendChild(tooltip);
		}
	});
	el.addEventListener('mouseleave', () => {
		const tooltip = el.querySelector('.Tooltip');
		if (tooltip) {
			tooltip.remove();
			const text = el.getAttribute('aria-label');
			el.setAttribute('title', text);
			el.removeAttribute('aria-label');
			el.classList.remove('Tooltip-parent');
		}
	});
};

// the following is used for non-vue applications when a directive isn't possible
const initializeTooltips = function () {
	const tooltips = document.querySelectorAll('[data-tooltip]');
	Array.prototype.forEach.call(tooltips, handleTooltips);
};
document.addEventListener('lichen:loaded', initializeTooltips);

import Vue from 'vue';
Vue.directive('clo-tooltip', {
	inserted: function (el) {
		handleTooltips(el);
	},
});
